import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { CardIconMap } from "@ui-kit/icons/CardIconMap";
import { useTranslation } from "@shared/utils/internationalization";
import { CartPaymentMethodsProps } from "./CartPaymentMethods.props";

export default function CartPaymentMethods({
  supportedCardTypes,
  boxSize = "element.2xl",
}: CartPaymentMethodsProps) {
  const { t } = useTranslation("purchases");
  const cardIcons = CardIconMap({ cardIconProps: { boxSize } });

  return (
    <Flex direction="column" fontWeight="bold" fontSize="sm">
      <Text textAlign="center">{t("Accepted Payment Methods")}</Text>
      <Flex gap="xs" align="center" justify="center" mt="xs">
        {supportedCardTypes.map((cardType) => (
          <span key={cardType}>{cardIcons[cardType]}</span>
        ))}
      </Flex>
    </Flex>
  );
}
